import { RocketIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const UpgradeBoost = () => {
  const navigate = useNavigate();

  return (
    <div>
      <button
        onClick={() => navigate(`/channels/@me/boost`)}
        className="group flex items-center"
      >
        <div className="mx-3 flex size-[48px] items-center justify-center overflow-hidden rounded-[24px] bg-background transition-all group-hover:rounded-[16px] group-hover:bg-black dark:bg-neutral-700">
          <RocketIcon
            className="text-indigo-500 transition-transform hover:rotate-12 group-hover:text-white"
            size={25}
          />
        </div>
        <style>{`
          @keyframes fadein {
            0% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
          @keyframes fadeout {
            0% {
              opacity: 1;
            }
            100% {
              opacity: 0.5;
            }
          }
        `}</style>
      </button>
    </div>
  );
};
